export const mouthoptions = [
	{ value: 'Bubble', label: 'Bubble', parm: 'mouth' },
	{ value: 'Cigar', label: 'Cigar', parm: 'mouth' },
	{ value: 'Gas Mask', label: 'Gas Mask', parm: 'mouth' },
	{ value: 'Gold Smile', label: 'Gold Smile', parm: 'mouth' },
	{ value: 'Jaw', label: 'Jaw', parm: 'mouth' },
	{ value: 'Joint', label: 'Joint', parm: 'mouth' },
	{ value: 'Neutral', label: 'Neutral', parm: 'mouth' },
	{ value: 'Smile', label: 'Smile', parm: 'mouth' },
	{ value: 'Tongue', label: 'Tongue', parm: 'mouth' },
];